import i18next from 'i18next'
import React from 'react'
import { formatDateDDMonthYYYY } from '../../../../utils/date'
import { ImageBase } from '../../../../utils/image'
import { GenericPageHeader } from '../../../sharedLayout/pageheader'
import { Link } from '../../../../utils/link'
import { DecorativeIcon } from '../../../../utils/spaarneIcons'
import { Link as LinkType } from '../../cmsPageState'

type EventPageHeaderProps = {
  eventDate: Date
  title: string
  intro: string
  image?: ImageBase
  link?: LinkType
  breadcrumbs: LinkType[]
  dossier?: LinkType
}

export const EventPageHeader = (props: EventPageHeaderProps) => (
  <GenericPageHeader
    kind="eventDetail"
    breadcrumbs={props.breadcrumbs}
    title={props.title || ''}
    intro={props.intro}
    link={props.link}
    image={props.image}
    extraJSXBelowTitle={
      <p className="pageheader__label">
        <span className="sr-text">{i18next.t('common:eventDate')}</span>
        {props.eventDate && (
          <time
            dateTime={props.eventDate.toISOString()}
            title={`${i18next.t('common:eventDate')} ${formatDateDDMonthYYYY(props.eventDate)}`}
          >
            {formatDateDDMonthYYYY(props.eventDate || '')}
          </time>
        )}
      </p>
    }
    extraJSXBelowText={
      <>
        {props.dossier?.title && props.dossier?.url && (
          <Link url={props.dossier.url} className={"dossier__label label--m"}>
            <DecorativeIcon iconId={"icon--folders"} width="20px" height="20px" />
            <span>{props.dossier.title ?? i18next.t("dossier:DossierTag")}</span>
          </Link>
        )}
      </>
    }
  />
)
